import React from "react";
import avatar from "../../assets/images/avatar.png";
import edit_pencil_icon from "../../assets//icons/edit_pencil_icon.png";
import attachment_pin_icon from "../../assets/icons/attachment_pin_icon.png";

const DueTasksModal = ({
  closeModal,
  setDueTasks,
  setDueCompleted,
  setCancelTask,
}) => {
  const handleDueCompleted = () => {
    setDueTasks(false);
    setDueCompleted(true);
  };

  const handleCancellingTask = () => {
    setDueTasks(false);
    setCancelTask(true);
  };
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[30%]">
        <div className="flex flex-col ">
          <div className="flex justify-center">
            <div className="text-[20px] font-bold">Due task</div>
          </div>

          <div className="flex items-center mt-6">
            <img src={avatar} alt="profile pic" className="w-6 rounded-full" />
            <p className="ml-2 text-[16px] font-bold">Praveen Sharma</p>
          </div>

          <div className="bg-white mt-4 border p-4 rounded-lg">
            <div className="flex justify-between">
              <p className="text-[14px] font-bold">Email invite template</p>
              <img src={edit_pencil_icon} className="object-contain w-4" alt="edit pencil"/>
            </div>
            <p className="text-[#91929E] text-[12px] mt-2">
              Hope you are doing well. This email is...
            </p>
            <div className="flex items-center mt-2">
              <div>
                <img
                  src={attachment_pin_icon}
                  className="w-10 cursor-pointer"
                  alt="attachments"
                />
              </div>
              <div className="ml-2 text-[#828282] text-[12px]">
                Attach for invite
              </div>
            </div>
          </div>

          <div className="mt-4">
            <p className="text-[12px] text-[#828282]">Add Comments/Notes</p>
            <input
              type="text"
              placeholder="Enter the comment"
              className="border w-full p-2 rounded-lg border-[#95C2FF] text-[16px]"
            />
          </div>

          <div className="flex justify-between my-5">
            <button
              className="w-6/12 bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg"
              onClick={handleCancellingTask}
            >
              Discard
            </button>
            <button
              className="w-6/12 bg-[#2F80ED] ml-2 p-2 text-white rounded-lg"
              onClick={handleDueCompleted}
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DueTasksModal;
